<template>
  <div class="detail_content">
    <div class="container">
      <div class="cont_box">
        <div class="left_img">
          <img v-if="detailInfo.text_course.image" :src="detailInfo.text_course.image" alt="" />
          <!-- <img v-else src="" alt=""> -->
          <p v-else>暂无封面</p>
        </div>
        <div class="right_text">
          <p class="title">{{ detailInfo.text_course.title }}</p>
          <p class="text">{{ detailInfo.text_course.introduction }}</p>
          <div class="btn" v-if="detailInfo.text_course_chapter.length>0">
            <p @click="lookfor()">查看</p>
          </div>
        </div>
      </div>
      <div class="tab_list">
        <ul class="tab_nav">
            <li @click="tabIndex='1'" :class="tabIndex=='1'?'active':''">详情</li>
            <li @click="tabIndex='2'" :class="tabIndex=='2'?'active':''">目录</li>
        </ul>
        <div class="cont_show" :class="tabIndex=='1'?'activeBox':''">
            <div v-if="detailInfo.text_course.introduction" v-html="detailInfo.text_course.introduction"></div>
            <p v-else>暂无详情</p>
        </div>
        <div class="cont_show menu_list" :class="tabIndex=='2'?'activeBox':''">
            <ul v-if="detailInfo.text_course_chapter.length>0">
                <li v-for="(item,index) in detailInfo.text_course_chapter" :key="item.id" @click="toPlay(item.id)">{{index+1}}.{{item.title}}</li>
            </ul>
            <p v-else>暂无目录</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "detail",
  data() {
    return {
      detailId: "",
      tabIndex:'1',
      detailInfo: {},
    };
  },
  mounted() {
    this.detailId = this.$route.query.id;
    if (this.detailId) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$axios
        .post(`/v1/textCourse/detail`, { id: this.detailId })
        .then((res) => {
          if (res.code == 0) {
            this.detailInfo = res.data;
          }
        });
    },
    lookfor(){
         this.$router.push('/textCourse/playText?id='+this.detailInfo.text_course_chapter[0].id+'&text_course_id='+this.detailId)
    },
    toPlay(id){
        this.$router.push('/textCourse/playText?id='+id+'&text_course_id='+this.detailId)
    }
  },
};
</script>

<style lang="scss" scoped>
.detail_content {
  background: #f6f6f6;
  padding: 30px 0;
  .container {
    width: 1200px;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    padding: 30px;
    .cont_box {
      display: flex;
      .left_img {
        width: 240px;
        height: 320px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        p{
          width: 100%;
          height: 100%;
          background: #f6f6f6;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          color: #999;
          letter-spacing: 5px;
        }
      }
      .right_text {
        margin-left: 20px;
        position: relative;
        flex: 1;
        p.title {
          font-size: 20px;
          font-weight: bold;
          margin-top: 15px;
        }
        p.text {
          margin-top: 10px;
          font-size: 15px;
        }
        div.btn {
            position: absolute;
            left: 20px;
            bottom: 20px;
          p {
            width: 120px;
            background: #254ed4;
            border-radius: 4px;
            padding: 20px 0;
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            line-height: 16px;
            box-sizing: border-box;
            cursor: pointer;
            text-align: center;
          }
        }
      }
    }
    .tab_list{
        margin-top: 30px;
        background: #fff;
        .tab_nav{
            display: flex;
            li{
                font-size: 20px;
                margin-right: 40px;
                padding-bottom: 10px;
                border-bottom: 2px solid #fff;
                cursor: pointer;
            }
            li.active{
                border-bottom: 2px solid #3ca7fa;
                font-weight: bold;
            }
        }
        .cont_show{
            margin-top: 30px;
        }

    }
    .cont_show{
        display: none;
        padding-bottom: 20px;
        p{
            line-height: 20px;
            font-size: 18px;
        }
    }
    .menu_list{
        ul{
            li{
                line-height: 40px;
                font-size: 16px;
                cursor: pointer;
            }
        }
    }
    .activeBox{
        display: block;
    }
  }
}
</style>